import withCondition from '@commons/withCondition';

import Text from './Text';

export default withCondition(Text);
